export const faqList = {
  faq1: {
    id: "faq1",
    title: "How much will this cost?",
    content:
      "After our invite-only beta, we will have volume-based subscription pricing for clients writing up to 30 blog posts a month. Higher volume clients should reach out to team@copysmith.ai for special pricing.",
    isOpen: false,
  },
  faq2: {
    id: "faq2",
    title: "Is the content original?",
    content:
      "Our AI writes copy word by word, which means it’s completely original.",
    isOpen: false,
  },
  faq3: {
    id: "faq3",
    title: "What's your data policy?",
    content:
      "We adhere to GDPR. Unless you ask us not to, we’ll add the blog post to our dataset. This means we’ll get even better at writing for you over time, just like a full time employee would.",
    isOpen: false,
  },
};
